import React from "react"
import Helmet from "react-helmet"

import Layout from "../components/layout"

const Schedule = () => (
  <Layout>
    <Helmet title="Schedule | Roberttables" />
    <h1>Schedule Page</h1>
  </Layout>
)

export default Schedule
